import easyfyAxios from '@shared/easyfy.axios';

export const GetProductOption = async (optionId: string, selectedSalesUnitCode: string | undefined): Promise<any> => {
  return await easyfyAxios.get(`/api/productoptionsselector?searchProductId=${optionId}&selectedSalesUnitCode=${selectedSalesUnitCode}`);
};

export const GetSubscriptionFlyoutView = async (productId: string): Promise<any> => {
  return await easyfyAxios.get(`/product?handler=subscriptionflyoutview&searchProdId=${productId}`);
};

export const GetSubscriptionFlyoutViewForProductList = async (productId: string): Promise<any> => {
  return await easyfyAxios.get(`/product?handler=subscriptionflyoutviewforproductlist&searchProdId=${productId}`);
};
